/* eslint-disable multiline-comment-style */
/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
// Core & Vendor Packages
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { toast } from 'react-toastify';
import { useState, useEffect } from 'react';
import CreatableSelect from 'react-select/creatable';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Form, Button, Container, Row, Col, Table } from 'react-bootstrap';

// Components
import { checkEmpty } from 'utils/validator';
import { selectAuth } from 'reducers/authReducer';
import FormText from 'components/GlobalUI/FormText';
import ImageUpload from 'components/GlobalUI/ImageUpload';
import PrivateLayout from 'components/GlobalUI/PrivateLayout';
import FormSelection from 'components/GlobalUI/FormSelection';
import ConfirmAction from 'components/GlobalUI/Modal/ConfirmAction/ConfirmAction';
import {
  getProduct,
  updateProduct,
  getProductState,
  deleteSubProduct,
} from 'reducers/productReducer';

// Assets
import styles from './index.module.scss';
import { ReactComponent as PlusSVG } from 'assets/svg/plus.svg';
import { ReactComponent as MinusSVG } from 'assets/svg/xmark.svg';
import { ReactComponent as AddRowSVG } from 'assets/svg/plusSign.svg';
import { ReactComponent as RemoveRow } from 'assets/svg/closeButton.svg';

const initialState = {
  image: '',
  price: '',
  foodCode: '',
  itemName: '',
  category: '',
  inventory: '',
  description: '',
  subProducts: [
    {
      id: uuidv4(),
      type: '',
      price: '',
      productName: '',
    },
  ],
};

// Main component
const UpdateProduct = () => {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const params = useParams();
  const { id } = params;

  const userState = useSelector(selectAuth);
  const { userInfo } = userState;

  const productState = useSelector(getProductState);
  const { updateLogs } = productState;

  const [showConfirm, setShowConfirm] = useState({
    type: '',
    data: null,
    show: false,
    submit: null,
  });

  const [categories, setCategories] = useState([]);

  const [formData, setFormData] = useState(initialState);

  const handleTableChange = (e, id) => {
    const { name, value } = e.target;

    const newData = formData?.subProducts?.map((dd) => {
      if (dd?.id === id) {
        return {
          ...dd,
          [name]: value,
        };
      }

      return dd;
    });

    setFormData((prev) => ({
      ...prev,
      subProducts: newData,
    }));
  };

  const handleCancel = () => {
    navigate('/products');
  };

  const addRow = () => {
    const newData = {
      id: uuidv4(),
      type: '',
      price: '',
      productName: '',
    };

    const addedData = formData?.subProducts?.concat([newData]);

    setFormData((prev) => ({
      ...prev,
      subProducts: addedData,
    }));
  };

  const removeRow = async (data) => {
    const apiData = new FormData();

    apiData.append('sub_product_id', data?.id);

    try {
      const response = await dispatch(deleteSubProduct(apiData));

      if (response?.meta?.requestStatus === 'rejected') {
        toast.error(response?.payload?.errors[0]?.detail);
        return;
      }

      if (response) {
        getProductInfo();
        toast.info('Successfully Deleted Sub Product');
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const handleUpdate = async () => {
    const saveData = {
      type: formData?.type,
      photo: formData?.image,
      price: formData?.price,
      name: formData?.itemName,
      code: formData?.foodCode,
      merchant_id: userInfo?.id,
      inventory: formData?.inventory,
      category: formData?.category,
      description: formData?.description,
    };

    let emptyCheck = false;
    emptyCheck = checkEmpty(saveData, ['inventory']);

    if (saveData?.type === 'Others' && saveData?.inventory === '') {
      toast.warning('Please fill in the empty fields');
      return;
    }

    if (emptyCheck) {
      toast.warning('Please fill in the empty fieldssss');
      return;
    }

    const apiData = new FormData();

    apiData.append('name', saveData?.name);
    apiData.append('code', saveData?.code);
    apiData.append('price', +saveData?.price);
    apiData.append('merchant_id', saveData?.merchant_id);
    apiData.append('category', saveData?.category?.value);
    apiData.append('description', saveData?.description);

    if (Array.isArray(saveData?.photo)) {
      apiData.append('photo', saveData?.photo[0]);
    }

    for (let index = 0; index < formData?.subProducts.length; index++) {
      const { productName, type, price, id } = formData.subProducts[index];

      if (productName !== '' && type !== '' && price !== '') {
        apiData.append(`product_variation[${index}][type]`, type);
        apiData.append(`product_variation[${index}][price]`, price);
        apiData.append(`product_variation[${index}][name]`, productName);
        apiData.append(`product_variation[${index}][id]`, id);
      }
    }

    try {
      const response = await dispatch(updateProduct({ params: apiData, id: formData?.id }));

      if (response?.meta?.requestStatus === 'rejected') {
        const errorArray = [].concat(...Object.values(response?.payload?.errors));

        if (errorArray && errorArray.length > 0) {
          errorArray.forEach((dd) => {
            toast.error(dd);
          });
        }

        return;
      }

      if (response) {
        toast.info('Successfully Updated Product');
        getProductInfo();
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const getProductInfo = async () => {
    try {
      const response = await dispatch(getProduct(id));

      const newData = {
        ...response?.payload?.data,
        price: response?.payload?.data?.price,
        foodCode: response?.payload?.data?.code,
        itemName: response?.payload?.data?.name,
        image: response?.payload?.data?.images?.photo,
        inventory: response?.payload?.data?.inventory,
        category: {
          value: response?.payload?.data?.category_id,
          label: response?.payload?.data?.category,
        },
        description: response?.payload?.data?.description,
        subProducts: response?.payload?.data?.subproducts.map((dd) => {
          return {
            ...dd,
            type: dd?.type,
            price: dd?.price,
            productName: dd?.name,
          };
        }),
      };

      setFormData(newData);
    } catch (error) {
      toast.error('Something went wrong.');
    }
  };

  const handleHideConfirm = () => {
    setShowConfirm({
      type: '',
      data: null,
      show: false,
      submit: null,
    });
  };

  const removeLocalRow = (id) => {
    const newData = formData?.subProducts?.filter((dd) => dd?.id !== id);

    setFormData((prev) => ({
      ...prev,
      subProducts: newData,
    }));
  };

  const handleRemoveRow = (dd) => {
    const result = formData?.subproducts.filter((sub) => sub?.id === dd?.id);

    if (result && result.length >= 1) {
      setShowConfirm({
        data: dd,
        show: true,
        submit: removeRow,
        type: 'delete sub product?',
      });
    } else {
      removeLocalRow(dd?.id);
    }
  };

  const handleCategoryChange = (data, actionMeta) => {
    // if (actionMeta.action === 'create-option') {
    //   setFormData((prev) => {
    //     return {
    //       ...prev,
    //       category: data,
    //     };
    //   });
    // } else {
    setFormData((prev) => {
      return {
        ...prev,
        category: data,
      };
    });
    // }
  };

  useEffect(() => {
    const getCategories = async () => {
      try {
        axios.get(`api/merchant-menus/${userInfo?.id}?per_page=1000`).then((response) => {
          setCategories(response?.data?.data);
        });
      } catch (error) {
        // console.log('Error', error);
      }
    };

    if (id) {
      getProductInfo();
      getCategories();
    }
  }, [id]);

  return (
    <PrivateLayout pageTitle='Update Product'>
      <Container>
        <Row className='mb-5'>
          <Col className={styles?.header}>
            <div className={styles?.text}>
              <h4>UPDATE PRODUCT</h4>
              <p>
                <span>PRODUCTS</span> / UPDATE PRODUCT
              </p>
            </div>
          </Col>
        </Row>

        <Row>
          <Col className='p-0'>
            <div className={styles?.updateProduct}>
              <p className={styles?.productHeader}>
                UPDATE PRODUCT <span>Enter Product Information Here</span>
              </p>

              <div className={styles?.form}>
                <div className={styles?.photo}>
                  <span>Photo</span>
                  <ImageUpload name='image' setState={setFormData} stateValue={formData?.image} />
                </div>

                <div className={styles?.column}>
                  <FormText
                    type='text'
                    name='Item Name'
                    setState={setFormData}
                    haveClass={styles?.fromGroup}
                    placeholder={'Enter Item Name'}
                    stateValue={formData?.itemName}
                  />
                  {/* 
                  <FormSelection
                    name='type'
                    setState={setFormData}
                    haveClass={styles?.fromGroup}
                    placeholder={'Enter type'}
                    stateValue={formData?.type}
                    options={[
                      { value: 'Food', label: 'Food' },
                      { value: 'Others', label: 'Others' },
                    ]}
                  /> */}

                  {formData?.type === 'Others' && (
                    <FormText
                      type='number'
                      name='Inventory'
                      setState={setFormData}
                      haveClass={styles?.fromGroup}
                      placeholder={'Enter Inventory'}
                      stateValue={formData?.inventory}
                    />
                  )}

                  <FormText
                    as='textarea'
                    type='textarea'
                    name='Description'
                    setState={setFormData}
                    rows={5}
                    placeholder={'Enter Description'}
                    stateValue={formData?.description}
                    haveClass={styles?.fromGroupDescrpition}
                  />
                </div>

                <div className={styles?.column}>
                  <FormText
                    type='number'
                    name='Price'
                    setState={setFormData}
                    placeholder={'Enter Price'}
                    stateValue={formData?.price}
                    haveClass={styles?.fromGroup}
                  />

                  <FormText
                    type='text'
                    name='Food Code'
                    setState={setFormData}
                    haveClass={styles?.fromGroup}
                    placeholder={'Enter Food Code'}
                    stateValue={formData?.foodCode}
                  />

                  <Form.Group className={styles?.group}>
                    <Form.Label>Category</Form.Label>

                    <div className={styles?.selectContainer}>
                      <CreatableSelect
                        styles={stylesOptions}
                        options={categories.map((category) => {
                          return {
                            ...category,
                            value: category?.id,
                            label: category?.name,
                          };
                        })}
                        value={formData?.category}
                        onChange={handleCategoryChange}
                      />
                    </div>
                  </Form.Group>
                </div>
              </div>

              <div className={styles?.subProducts}>
                {formData?.subProducts &&
                  formData?.subProducts.length >= 1 &&
                  formData?.subProducts.map((dd) => {
                    return (
                      <div key={dd?.id} className={styles?.subProduct}>
                        <Form.Group className={styles?.group}>
                          <Form.Label>Product Name</Form.Label>
                          <Form.Control
                            name='productName'
                            value={dd?.productName}
                            onChange={(e) => {
                              handleTableChange(e, dd?.id);
                            }}
                          />
                        </Form.Group>

                        <Form.Group className={styles?.smallGroup}>
                          <Form.Label>Type</Form.Label>
                          <Form.Control
                            name='type'
                            value={dd?.type}
                            onChange={(e) => {
                              handleTableChange(e, dd?.id);
                            }}
                          />
                        </Form.Group>

                        <Form.Group className={styles?.smallGroup}>
                          <Form.Label>Price</Form.Label>
                          <Form.Control
                            name='price'
                            type='number'
                            value={dd?.price}
                            onChange={(e) => {
                              handleTableChange(e, dd?.id);
                            }}
                          />
                        </Form.Group>

                        <Form.Group className={styles?.buttons}>
                          <AddRowSVG onClick={addRow} />

                          {formData?.subProducts.length > 1 && (
                            <RemoveRow onClick={() => handleRemoveRow(dd)} />
                          )}
                        </Form.Group>
                      </div>
                    );
                  })}
              </div>

              <div className={styles?.actions}>
                <Button
                  onClick={handleUpdate}
                  className={styles?.add}
                  disabled={updateLogs?.isLoading}
                >
                  <PlusSVG />
                  UPDATE PRODUCT
                </Button>
                <Button className={styles?.cancel} onClick={handleCancel}>
                  <MinusSVG />
                  CANCEL
                </Button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      <ConfirmAction
        data={showConfirm?.data}
        show={showConfirm?.show}
        type={showConfirm?.type}
        onHide={handleHideConfirm}
        handleConfirm={showConfirm?.submit}
      />
    </PrivateLayout>
  );
};

const stylesOptions = {
  control: (baseStyles, state) => ({
    ...baseStyles,
    height: '38px',
    border: 'none',
    fontWeight: 400,
    fontSize: '14px',
    borderRadius: '8px',
    background: '#EAEDF0',
  }),
  menuList: (baseStyles, state) => ({
    ...baseStyles,
    fontWeight: 400,
    fontSize: '14px',
    background: '#EAEDF0',
  }),
};

export default UpdateProduct;
